export const uploadFileLimit = 25 * 1024 ** 2; // 25Mb
